import type { ReactNode } from 'react';
import { PlatformProvider } from '@/platform';
import { AnalyticsErrorBoundary } from '@/shared/lib/analytics';
import { DialogHost } from '@/shared/lib/dialog';
import { ConnectionStatusProvider } from './ConnectionStatusProvider';

/**
 * Composition root for cross-cutting providers. `PlatformProvider` mounts
 * first because every downstream provider (and most features) needs to read
 * the active platform tag and the platform-bound identity provider through
 * context. `ConnectionStatusProvider` mounts the single app-wide
 * ConnectionBanner so it survives navigation between online phases instead
 * of being re-mounted per orchestrator. Future providers (Query,
 * ThemeProvider, …) wrap inside this tree.
 */
export const AppProviders = ({ children }: { children: ReactNode }) => (
  <PlatformProvider>
    <ConnectionStatusProvider>
      <AnalyticsErrorBoundary>{children}</AnalyticsErrorBoundary>
      <AnalyticsErrorBoundary>
        <DialogHost />
      </AnalyticsErrorBoundary>
    </ConnectionStatusProvider>
  </PlatformProvider>
);
